import { render, staticRenderFns } from "./InstitutionLogin.vue?vue&type=template&id=b9681908&scoped=true&"
import script from "./InstitutionLogin.vue?vue&type=script&lang=js&"
export * from "./InstitutionLogin.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionLogin.vue?vue&type=style&index=0&id=b9681908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9681908",
  null
  
)

export default component.exports